import { Link } from "@tanstack/react-router";
import { config } from "@/data/config";
import { cn } from "@/lib/utils";
import {
	Accordion,
	AccordionContent,
	AccordionItem,
	AccordionTrigger,
} from "../ui/accordion";

export const BillingFaqs = () => {
	return (
		<div className={cn("mt-8", "marketing-neutral-headings")}>
			<Accordion className="col-span-full">
				<AccordionItem value="payment-security">
					<AccordionTrigger>
						How do you protect my payment information?
					</AccordionTrigger>
					<AccordionContent>
						We use{" "}
						<a
							href="https://stripe.com/security"
							target="_blank"
							rel="noopener noreferrer"
							className="text-blue-500 hover:text-blue-600 underline underline-offset-2"
						>
							Stripe
						</a>
						, a PCI-compliant payment processor, to handle all payments. Your
						payment information is never stored on our servers and is securely
						encrypted using industry-standard protocols.
					</AccordionContent>
				</AccordionItem>

				<AccordionItem value="billing-cycles">
					<AccordionTrigger>When and how am I billed?</AccordionTrigger>
					<AccordionContent>
						You can choose between monthly or annual billing cycles using the
						toggle above the plans. Annual subscriptions come with a discount.
						Your subscription will automatically renew unless cancelled, and
						you'll receive email notifications before any charges.
					</AccordionContent>
				</AccordionItem>

				<AccordionItem value="refunds">
					<AccordionTrigger>What is your refund policy?</AccordionTrigger>
					<AccordionContent>
						You can cancel your subscription at any time via the 'Manage
						Subscription' button (if subscribed). If you are not satisfied with
						the service, please contact us at{" "}
						<a
							href={`mailto:${config.supportEmail}`}
							className="text-blue-500 hover:text-blue-600 underline underline-offset-2"
						>
							{config.supportEmail}
						</a>{" "}
						and we will consider issuing a refund based on the circumstances.
					</AccordionContent>
				</AccordionItem>

				<AccordionItem value="payment-methods">
					<AccordionTrigger>
						What payment methods do you accept?
					</AccordionTrigger>
					<AccordionContent>
						We accept all major credit cards (Visa, Mastercard, American
						Express) and debit cards processed through Stripe. For enterprise
						customers, alternative arrangements may be possible upon request.
						<br />
						<br />
						At this time, we{" "}
						<b className="underline underline-offset-2">do not</b> accept
						PayPal, Venmo, Cash App, or Crypto currencies.
					</AccordionContent>
				</AccordionItem>

				<AccordionItem value="currency">
					<AccordionTrigger>Which currencies do you support?</AccordionTrigger>
					<AccordionContent>
						All charges are processed in USD ($). If you're paying with a card
						in a different currency, your bank will handle the conversion using
						their current exchange rates.
					</AccordionContent>
				</AccordionItem>

				<AccordionItem value="invoices">
					<AccordionTrigger>How do I get my invoices?</AccordionTrigger>
					<AccordionContent>
						You can view your invoices by clicking the 'Manage Subscription'
						button (if subscribed). This will redirect you to the Stripe payment
						portal where you can view your invoices, and modify your payment
						method, address and Tax Identification Number (TIN, VAT ID, etc).
						<br />
						<br />
						<b>
							Please do not update your email address on Stripe, but instead
							update it in the <Link to="/user/settings">settings</Link> page.
						</b>
					</AccordionContent>
				</AccordionItem>
			</Accordion>
		</div>
	);
};
